import {AppRouteType} from "../../Components/Templates/AppRouter/AppRouteType";
import { Route } from "react-router-dom";
import { AppRoutes } from "../../../Core/App/AppRoutes";
import { LoginPage } from "../../Pages/Auth/LoginPage/LoginPage";

const loginRoute: AppRouteType = {
    id: AppRoutes.LOGIN,
    render: Route,
    props: {
        exact: true,
        path: AppRoutes.LOGIN,
        component: LoginPage,
    },
}

export const getAuthRoutes = () => [loginRoute];